import { render, staticRenderFns } from "./NbConfirm.vue?vue&type=template&id=413348f2"
import script from "./NbConfirm.vue?vue&type=script&lang=js"
export * from "./NbConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports